import { render, staticRenderFns } from "./NewsDetails.vue?vue&type=template&id=e1cfbff4&scoped=true"
import script from "../controllers/NewsDetails.ts?vue&type=script&lang=ts&external"
export * from "../controllers/NewsDetails.ts?vue&type=script&lang=ts&external"
import style0 from "./NewsDetails.vue?vue&type=style&index=0&id=e1cfbff4&prod&scoped=true&lang=css"
import style1 from "./NewsDetails.vue?vue&type=style&index=1&id=e1cfbff4&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1cfbff4",
  null
  
)

export default component.exports